import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
const routes = [{
    path: '/HomePage',
    name: 'HomePage',
    meta: {
      title: '主页'
    },
    component: () => import('@/views/HomePage')
  },
  {
    path: '/EnvirMonitor',
    name: 'EnvirMonitor',
    meta: {
      title: '环境监测'
    },
    component: () => import('@/views/EnvirMonitor')
  },
  {
    path: '/Video',
    name: 'Video',
    meta: {
      title: '视频监控'
    },
    component: () => import('@/views/Video')
  },
  {
    path: '/Irrigation',
    name: 'Irrigation',
    meta: {
      title: '智能灌溉'
    },
    component: () => import('@/views/Irrigation')
  },
  {
    path: '/IoTDisplay',
    name: 'IoTDisplay',
    meta: {
      title: '实时物联网数据展示'
    },
    component: () => import('@/views/IoTDisplay')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/Login')

  },
  {
    path: "/",
    redirect: "/HomePage"
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})



export default router;